// 埋点页面链接：https://stream.jd.com/ddrx/#/requirement/25336
// WARNING!!! 请勿手动修改此文件，如需修改请在子午线平台变更后，执行npm run track-init 25336
import { eventTrackingUtils } from "@/utils/eventTrack/eventTrackingUtils";
export const PageId = Object.freeze({
  Evaluate_CommentComplete: "Evaluate_CommentComplete",
});

interface IPVTrackParamsRecord {
  /** 评价完成页 */
  Evaluate_CommentComplete: {
    /** 订单id  */
    orderId: string;
    /** 评价id  */
    commentId: string;
  };
}

const sendPv = {
  /** PV-评价完成页 */
  Evaluate_CommentComplete: (page_param: IPVTrackParamsRecord["Evaluate_CommentComplete"]) => {
    eventTrackingUtils.submitPV({ page_id: PageId.Evaluate_CommentComplete, page_param });
  },
};

interface IExpoTrackParamsRecord {
  /** 按钮曝光 */
  Evaluate_CommentComplete_Btn_Expo: {
    /** 按钮名称  */
    button_name: string;
  };
  /** 待评价列表曝光 */
  Evaluate_CommentComplete_Score_Expo: {
    /** 商品id  */
    skuid: string;
    /** 订单id  */
    orderId: string;
  };
  /** 去评价按钮曝光 */
  Evaluate_CommentComplete_Reivew_Expo: {
    /** 商品id  */
    skuid: string;
    /** 订单id  */
    orderId: string;
  };
}

const EXPOSURE_RECORD: Readonly<Record<keyof IExpoTrackParamsRecord, string>> = Object.freeze({
  /** 按钮曝光 */
  Evaluate_CommentComplete_Btn_Expo: "Evaluate_CommentComplete_Btn_Expo",
  /** 待评价列表曝光 */
  Evaluate_CommentComplete_Score_Expo: "Evaluate_CommentComplete_Score_Expo",
  /** 去评价按钮曝光 */
  Evaluate_CommentComplete_Reivew_Expo: "Evaluate_CommentComplete_Reivew_Expo",
});

interface IClickTrackParamsRecord {
  /** 按钮点击 */
  Evaluate_CommentComplete_Btn: {
    /** 按钮名称  */
    button_name: string;
  };
  /** 待评价评分点击 */
  Evaluate_CommentComplete_Score: {
    /** 商品id  */
    skuid: string;
    /** 订单id  */
    orderId: string;
  };
  /** 去评价按钮点击 */
  Evaluate_CommentComplete_Reivew: {
    /** 商品id  */
    skuid: string;
    /** 订单id  */
    orderId: string;
  };
}

const sendClickTrack = {
  /** 点击事件上报-按钮点击 */
  Evaluate_CommentComplete_Btn: (json_param: IClickTrackParamsRecord["Evaluate_CommentComplete_Btn"]) => {
    eventTrackingUtils.submitCL({ event_id: "Evaluate_CommentComplete_Btn", json_param });
  },
  /** 点击事件上报-待评价评分点击 */
  Evaluate_CommentComplete_Score: (json_param: IClickTrackParamsRecord["Evaluate_CommentComplete_Score"]) => {
    eventTrackingUtils.submitCL({ event_id: "Evaluate_CommentComplete_Score", json_param });
  },
  /** 点击事件上报-去评价按钮点击 */
  Evaluate_CommentComplete_Reivew: (json_param: IClickTrackParamsRecord["Evaluate_CommentComplete_Reivew"]) => {
    eventTrackingUtils.submitCL({ event_id: "Evaluate_CommentComplete_Reivew", json_param });
  },
};

export { EXPOSURE_RECORD, sendClickTrack, sendPv };
export type { IExpoTrackParamsRecord };
